<template>
  <div class="mains">
    <div class="campus">
      小程序管理
      <span>></span>
      <router-link to="miniProduct">产品信息管理</router-link>
    </div>
    <div class="xiaoqu">
      <el-card :span="24">
        <div class="grid-content xcx_qxsz">
          <div class="xiaoqu_1">产品信息管理</div>
          <div class="quanxiantishi">
            您可在此处进行小程序售卖产品信息的维护
          </div>
          <div class="sousuo">
            <el-input v-model="content" @keyup.13.native="chaxun" placeholder="产品描述模糊查询"></el-input>
            <el-button type="primary" class="buttons" @click="chaxun()">
              查 询
            </el-button>
            <el-button type="success" class="buttons" @click="addProduct">
              新增产品
            </el-button>
          </div>
          <div class="zsbg jigou_xcx">
            <el-table :data="tableData" border style="width: 100%">
              <el-table-column prop="title" label="产品名称" header-align="center" align="center"></el-table-column>
              <el-table-column prop="content" label="产品描述" header-align="left" align="left"></el-table-column>
              <el-table-column prop="description" label="详细描述" header-align="center" align="center"></el-table-column>
              <el-table-column prop="discont" label="原价" header-align="right" align="right"></el-table-column>
              <el-table-column prop="price" label="现价" header-align="center" align="center"></el-table-column>
              <el-table-column prop="type" label="类型" header-align="center" align="center"></el-table-column>
              <el-table-column prop="create_date" label="上架时间" header-align="center" align="center"></el-table-column>

              <el-table-column label="操作">
                <template slot-scope="stData">
                  <el-button type="text" class="caozuo" @click="editProduct(stData.row)">
                    编辑
                  </el-button>
                  <el-button
                    style="margin-left: 5px"
                    @click="delProduct(stData.row)"
                  >
                    删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <el-dialog :title="isEdit ? '编辑产品信息' : '新增产品信息'" :visible.sync="addStudents">
            <div class="form_1 form_1_1 xcx_sz">
              <el-form label-position="left" label-width="100px" :model="miniProduct" :rules="FormRules" ref="productForm">
                <el-form-item label="产品名称" prop="title">
                  <el-input v-model="miniProduct.title" ></el-input>
                </el-form-item>
                <el-form-item label="产品描述" prop="content">
                  <el-input v-model="miniProduct.content"></el-input>
                </el-form-item>
                <el-form-item label="详细描述" prop="description">
                  <el-input type="textarea" v-model="miniProduct.description"></el-input>
                </el-form-item>
                <el-form-item label="原价" prop="discont" placeholder="元">
                  <el-input v-model.number="miniProduct.discont" type="number"></el-input>
                </el-form-item>
                <el-form-item label="现价" prop="price" placeholder="元">
                  <el-input v-model.number="miniProduct.price" type="number"></el-input>
                </el-form-item>
                <el-form-item label="可用时长" prop="price">
                  <el-input v-model.number="miniProduct.duration" placeholder="输入可用时长(单位为天，-1表示永久)" type="number"></el-input>
                </el-form-item>
                <el-form-item label="类型" prop="type">
                  <el-select v-model="miniProduct.type" placeholder="请选择类型">
                    <el-option label="1：测评条数" value="1"></el-option>
                    <el-option label="2：测评条数" value="2"></el-option>
                    <el-option label="3：月卡（暂未启用）" value="3"></el-option>
                    <el-option label="101：新飞跃课程 1A" value="101"></el-option>
                    <el-option label="102：新飞跃课程 1B" value="102"></el-option>
                    <el-option label="103：新飞跃课程 2A" value="103"></el-option>
                    <el-option label="104：新飞跃课程 2B" value="104"></el-option>
                    <el-option label="105：新飞跃课程 3A" value="105"></el-option>
                    <el-option label="106：新飞跃课程 3B" value="106"></el-option>
                    <el-option label="107：新飞跃课程 4A" value="107"></el-option>
                    <el-option label="108：新飞跃课程 4B" value="108"></el-option>
                    <el-option label="109：新飞跃课程 5A" value="109"></el-option>
                    <el-option label="110：新飞跃课程 5B" value="110"></el-option>
                    <el-option label="111：新飞跃课程 6A" value="111"></el-option>
                    <el-option label="112：新飞跃课程 6B" value="112"></el-option>
                  </el-select>
                </el-form-item>

                <!-- 修改: 仅在新增时隐藏 mini_appids 多选框，替换为提示 -->
                <el-form-item v-if="!isEdit" label="上架小程序" prop="mini_appids">
                  <div>新增成功后可在编辑页面选择该产品需要上架的小程序！</div>
                </el-form-item>
                <el-form-item v-if="isEdit" label="上架小程序" prop="mini_appids">
                  <el-select v-model="miniProduct.mini_appids" multiple placeholder="请选择">
                    <el-option
                      v-for="(item, key, index) in miniList"
                      :key="index"
                      :label="'【' + item.miniName + '】 / ' + item.orgName + ' / ' + item.orgCode"
                      :value="item.appid"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item size="large">
                  <el-button type="primary" @click="submitProduct">{{ isEdit ? '保存' : '创建' }}</el-button>
                  <el-button @click="addStudents = false;">取消</el-button>
                </el-form-item>
              </el-form>
            </div>
          </el-dialog>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'miniProduct',
  data() {
    return {
      miniProduct: {
        title: '',
        content: '',
        description: '',
        discont: '',
        price: '',
        type: '',
        duration: '',
        mini_appids: [],
      },
      content: '',
      miniName: '',
      miniId: '',
      xcx_type: '',
      tableData: [],
      miniList: [],
      FormRules: {
        title: [{ required: true, message: '请输入产品名称', trigger: 'blur' }],
        content: [{ required: true, message: '请输入产品描述', trigger: 'blur' }],
        discont: [
          { required: true, message: '请输入原价', trigger: 'blur' },
          { type: 'number', min: 0.01, message: '原价必须大于0', trigger: 'blur' }
        ],
        price: [
          { required: true, message: '请输入现价', trigger: 'blur' },
          { type: 'number', min: 0.01, message: '现价必须大于0', trigger: 'blur' }
        ],
        duration: [
          { required: true, message: '输入可用天数(-1表示永久)', trigger: 'blur' },
          { type: 'number', message: '必须为数字', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '产品类型不能为空', trigger: 'blur' },
        ],
      },
      addStudents: false,
      isEdit: false,
    };
  },
  mounted() {
    this.getOldMiniInfoList();
    this.chaxun();
  },
  methods: {
    getOldMiniInfoList(){
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      this.$http({
        url: '/mini/miniProduct/getOldMiniInfoList',
        method: 'POST',
        data: {
          miniName: this.miniName,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      })
        .then((result) => {
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.miniList = result.data.data;
        })
        .catch((err) => {
          return this.$message.error('获取小程序列表失败：' + err);
        });
    },
    chaxun() {
      // 查询产品信息
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      this.$http({
        url: '/mini/miniProduct/selectProductList',
        method: 'POST',
        data: {
          content: this.content,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      })
        .then((result) => {
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.tableData = result.data.data;
          this.total = result.data.size;
        })
        .catch((err) => {
          return this.$message.error('获得产品列表失败：' + err);
        });
    },
    addProduct() {
      this.isEdit = false;
      this.addStudents = true;
      this.miniProduct = {
        title: '',
        content: '',
        description: '',
        discontprice: '0',
        discont: '',
        price: '',
        type: '',
        duration: '',
        mini_appids: [],
        status: '1'
      };
    },
    editProduct(row) {
      this.isEdit = true;
      this.addStudents = true;
      this.miniProduct = { ...row };
    },
    delProduct(row) {
      this.$confirm('确认要删除吗?', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
        let url = '/mini/miniProduct/updateProduct';
        this.$http({
          url: url,
          method: 'POST',
          data: {
            id: row.id,
            is_valid: '0'
          },
          headers: {
            Authorization: 'Bearer ' + token,
          },
        })
          .then((result) => {
            if (result.data.code !== 0) {
              return this.$message.error(result.data.message);
            }
            this.chaxun();
            this.$message.success('删除成功');
          })
          .catch((err) => {
            return this.$message.error('操作失败：' + err);
          });
      });
    },
    submitProduct() {
      this.$refs.productForm.validate((valid) => {
        if (valid) {
          let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
          let url = this.isEdit ? '/mini/miniProduct/updateProduct' : '/mini/miniProduct/addProduct';
          this.$http({
            url: url,
            method: 'POST',
            data: this.miniProduct,
            headers: {
              Authorization: 'Bearer ' + token,
            },
          })
            .then((result) => {
              if (result.data.code !== 0) {
                return this.$message.error(result.data.message);
              }
              this.addStudents = false;
              this.chaxun();
              this.$message.success(this.isEdit ? '更新成功' : '创建成功');
            })
            .catch((err) => {
              return this.$message.error('操作失败：' + err);
            });
        }
      });
    },
  },
};
</script>

<style lang="less">
.mains .xiaoqu .xcx_qxsz {
  .quanxiantishi {
    color: #ccc;
    font-size: 12px;
  }
  .sousuo {
    margin-top: 5px;
    display: flex;
    align-items: center;
    gap: 10px;
  }
}

.mains .xiaoqu .grid-content {
  .jigou_xcx .el-table {
    margin-top: 60px;
    .el-table__header-wrapper {
      background-color: #f5f7fa;
    }
  }

  .el-dialog .xcx_sz {
    .el-form-item {
      margin-bottom: 20px;
    }
    .el-button {
      margin-right: 10px;
    }
  }
}
</style>
